import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { UserPlus, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

export default function Register() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const { register, formatApiErrorDetail } = useAuth();
  const navigate = useNavigate();
  const set = (k) => (e) => setForm((s) => ({ ...s, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Account created");
      navigate("/dashboard", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="container-app py-20 grid lg:grid-cols-12 gap-10" data-testid="register-page">
      <div className="lg:col-span-6 hidden lg:flex flex-col justify-center">
        <span className="section-eyebrow">Sign up</span>
        <h1 className="font-display text-5xl mt-4 text-navy">Create your ScholarPrintHub account.</h1>
        <p className="text-slate-600 mt-4">Save file uploads, track quotations, and re-order printing with one click.</p>
      </div>
      <form onSubmit={submit} className="lg:col-span-6 border border-slate-200 rounded-sm p-8 bg-white max-w-md w-full mx-auto">
        <div className="section-eyebrow">Create account</div>
        <div className="mt-4 space-y-4">
          <div><Label className="text-xs">Full name</Label><Input required value={form.name} onChange={set("name")} data-testid="reg-name" /></div>
          <div><Label className="text-xs">Email</Label><Input type="email" required value={form.email} onChange={set("email")} data-testid="reg-email" /></div>
          <div><Label className="text-xs">Mobile number</Label><Input value={form.phone} onChange={set("phone")} data-testid="reg-phone" /></div>
          <div><Label className="text-xs">Password</Label><Input type="password" required minLength={6} value={form.password} onChange={set("password")} data-testid="reg-password" /></div>
        </div>
        <button type="submit" disabled={loading} data-testid="reg-submit" className="btn-primary w-full mt-6">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <UserPlus className="w-4 h-4" />} Create account
        </button>
        <div className="text-xs text-slate-500 mt-4 text-center">
          Already have an account? <Link to="/login" className="text-royal hover:underline">Sign in</Link>
        </div>
      </form>
    </div>
  );
}
